import o from "./highrise648.mjs";
import i from "./highrise1345.mjs";
import m from "./highrise1586.mjs";
import f from "./highrise1408.mjs";
function c(r, t) {
  return o(r) ? r : i(r, t) ? [r] : m(f(r));
}
export {
  c as default
};
